export enum TableStyle {
    Short,
    Extended
}
